import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse, Pagination } from 'interfaces/api.interfaces'
import { Manual, Manuals } from 'interfaces/api/manuals.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

const getAll = async (type: Manuals, params: Partial<Pagination>): GetAllResponse<Manual> => {
  const { data: response } = await axios.request<GetAllData<Manual>>({
    method: 'GET',
    url: endpoints.manuals.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
      dict_type: type,
    },
  })
  return response
}

const update = async (type: Manuals, manual: Manual): GetOneResponse<Manual> => {
  const { data: response } = await axios.request<Manual>({
    method: 'PATCH',
    url: endpoints.manuals.update(manual.id),
    data: {
      dictType: type,
      ...manual,
    },
  })
  return response
}

const create = async (type: Manuals, manual: Manual): GetOneResponse<Manual> => {
  const { data: response } = await axios.request<Manual>({
    method: 'POST',
    url: endpoints.manuals.create(),
    data: {
      dictType: type,
      ...manual,
    },
  })
  return response
}

const remove = async (type: Manuals, id: number): Promise<void> => {
  await axios.request({
    method: 'DELETE',
    url: endpoints.manuals.remove(id),
    data: {
      dictType: type,
    },
  })
}

export const manualsApi = {
  getAll,
  update,
  create,
  remove,
}
